import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";

import ContainerRoute from "../../components/routing/container-route";
import { LibraryList } from "./list";

export default ({ responsiveStyles = {} }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={path}
        component={LibraryList}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
    </Switch>
  );
};
